import { type Enum } from '../../utils/enums'

export const VendorRequestStatuses = {
  PENDING: 1,
  APPROVED: 2,
  DENIED: 3,
} as const

export type VendorRequestStatus = Enum<typeof VendorRequestStatuses>
